import shared from './shared';

/**
 * @param {Object}            server       Mirage Server
 * @param {Object}            options      Options to create extra models, see deconstructed object below for keys
 */
export default function (server, options = {}) {
  const { isTrialExpired = false } = options;

  const {
    company,
    locations: [SFLocation, NYLocation],
  } = shared(server);

  const workplaceSubscription = server.create(
    'subscription',
    'asWorkplacePremium',
    isTrialExpired ? 'asTrialExpired' : 'asTrial',
    {
      company,
      app: 'empxp',
    }
  );

  const deliveriesSubscription = server.create(
    'subscription',
    'asDeliveriesOnTrial',
    isTrialExpired ? 'asTrialExpired' : 'asTrial',
    {
      companyId: company.id,
      plan: 'standard',
      isManual: false,
    }
  );

  const roomsSubscription = server.create('subscription', 'asPremium', isTrialExpired ? 'asTrialExpired' : 'asTrial', {
    company,
    app: 'rooms',
  });

  const desksSubscription = server.create(
    'subscription',
    'asDesksOnTrial',
    `asPremium`,
    isTrialExpired ? 'asTrialExpired' : 'asTrial',
    {
      company,
      app: 'rooms',
    }
  );

  return {
    company,
    workplaceSubscription,
    deliveriesSubscription,
    roomsSubscription,
    desksSubscription,
    locations: [SFLocation, NYLocation],
  };
}
